import { authClient, baseClient, getServiceURL } from '@/utils'
import { ApiCaller } from '@front/utils'
import Toggles from '@domain/toggles/Toggles';

const designerDetails = (subfamilyId) => baseClient.get(`${getServiceURL('apiv2')}/subfamily/${subfamilyId}/designer`)

const fetchCollections = ({ catalogId, lang, subFamilyId, withImages = true, rolId }) => {
	if (Toggles.isEnabled('productsArticlesWithRedis')) {
		let url = `products/articles/collections?catalogId=${catalogId}&lang=${lang}&images=${withImages ? 1 : undefined}&subFamilyId=${subFamilyId}`
		if (Toggles.isEnabled('productsArticlesWithRoleId') && rolId) url += `&role=${rolId}`

		return ApiCaller.call('v2', 'GET', url)
	} else {
		return authClient.get(`${getServiceURL('products')}/v1/articles/collections`, {
			params: {
				catalogId,
				lang,
				subFamilyId,
				images: withImages ? 1 : undefined
			}
		})
	}
}

export default {
	designerDetails,
	fetchCollections
}
